import React, {  useEffect, useState } from 'react'
import EditableText from './editabletext'
import { RhyBusButton } from '@rhybus/button'
import { rhybusRListsHttp } from '../../../api/rhybus-list-http'
import { ListNames, SelectOption } from '../../../config/configuration'

import { getCurrentUTCDate } from './formatcontent'
import { RhyBusCustomSelect, RhyBusTextArea, RhyBusInputText } from '@rhybus/form-controls'
import PageOverlay from '../../../utils/controls/pageoverLay/pageoverLay'

const PiiConfiguration: React.FC = () => {
  const [userDefinedCat, setUserDefinedCat] = useState([])
  const [preDefinedCat, setPreDefinedCat] = useState<any>([])
  const [piiFormates, setPIIFormates] = useState([])
  const [catName, setCatName] = useState('')
  const [severity, setSeverity] =   useState<SelectOption | null>(null)  
  const [catContext, setCatContext] = useState('')
  const [enableNewCat, setEnableNewCat] = useState('false')
  const [catNewError, setCatNewError] = useState(false)
  const [, setSeverityNewError] = useState(false)
  const [showDiv, setShowDiv] = useState(false)

  const [isDisable, setIsDisable] = useState(false)
  const [loading, setLoading] = useState(false)
 
  const getCategoryTypeData = async () => {
    try {
      const list = await rhybusRListsHttp().getList(ListNames.PIICATEGORY)
      const data = [...(await list.query().orderBy([{orderBy: 'ItemModified', ascending: false}]).get<any>())]
      separateUserPredefinedCategories(data)
    } catch (error) {
      console.error('Error fetching category data:', error)
    }
  }
  const getPIIFormates = async () => {
    try {
      const list = await rhybusRListsHttp().getList(ListNames.PII_FORMATS)
      const data = [...(await list.query().orderBy([{orderBy: 'ItemModified', ascending: false}]).get<any>())]
      setPIIFormates(data)
    } catch (error) {
      console.error('Error fetching PII formats:', error)
    }
  }
  function separateUserPredefinedCategories(categories: any) {
    const preDefinedCategory: any = []
    const userDefinedCategory: any = []
    categories.forEach((i: { ParamMode: string }) => {
      if (i?.ParamMode === 'P') { preDefinedCategory.push(i) } else { userDefinedCategory.push(i) }
    })
    setPreDefinedCat(preDefinedCategory)
    setUserDefinedCat(userDefinedCategory)
  }
 
  const addNewCat = async () => {
    if (catName?.trim() !== '' && severity?.value !== '') {
      setLoading(true)
      setIsDisable(true)
      setCatNewError(false)
      setSeverityNewError(false)
      const ObjectArray: any = {
        // CID: '0',
        Title: '',
        CategoryParamName: catName,
        CategoryContext: catContext,
        ParamMode: 'U',
        Severity: severity,
        ParamAllowedDataTypes: '1,2,3,9',
        IsEnable: enableNewCat,
        ItemModifiedById: (window as any)._spPageContextInfo?.userId ?? 0,
        ItemModified: getCurrentUTCDate(),
        ItemCreated: getCurrentUTCDate(),
        ItemCreatedById: (window as any)._spPageContextInfo?.userId ?? 0
      }
      const list = await rhybusRListsHttp().getList(ListNames?.PIICATEGORY)
      const result: any = await list.addOrUpdateItem(ObjectArray as any)
      const CID = (result as any)?.eKey || result
      const updateCID: any = {
        eKey: String(CID),
        CID: CID,
        ID: CID
      }
      await list.addOrUpdateItem(updateCID as any)
      setIsDisable(false)
      setLoading(false)
      setShowDiv(false)
      await getCategoryTypeData()
    } else {
      setIsDisable(false)
      if (catName?.trim() === '') { setCatNewError(true) } else { setCatNewError(false) }
      if (severity?.value === '') { setSeverityNewError(true) } else { setSeverityNewError(false) }
    }
  }
  const SELECT_VALUE: SelectOption[] = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
  ]
   useEffect(() => {
    setEnableNewCat('false')
    getCategoryTypeData()
    getPIIFormates()
  }, [])
  return (
    <>
      {loading && <PageOverlay />}
      <div className="container">
        <div className="py-3">
          <h3 tabIndex={0} aria-label='Pre - Defined Categories' className='mb-2 font-14 color-primary poppins-semibold '>Pre - Defined Categories</h3>
          <div className='whitebg border-2 border-radius overflow-hidden predefinedcat'>
            <EditableText Items={preDefinedCat} formats={piiFormates} getData={getPIIFormates} getCategories={getCategoryTypeData} isPredefinedCategories={true} />
          </div>
          <div className='d-flex pt-3 pb-2 align-items-center'>
            <h3 tabIndex={0} aria-label='User - Defined Categories' className='font-14 color-primary poppins-semibold '>User - Defined Categories</h3>
            <RhyBusButton
              label="New Category"
              aria-label="New Category"
              leftIcon="icon-rb-add me-1 font-11"
              onClick={() => {
                setShowDiv(!showDiv)
                setCatName('')
                // setSeverity('')
                setCatContext('')
              }}
            />
          </div>
          {showDiv &&
            <div className='card shadow-1 border-radius mb-2'>
              <div className="d-flex p-2 justify-content-between border-bottom-2 align-items-center">
                <h3 tabIndex={0} aria-label='Add New Category' className='font-14 poppins-semibold darktext'>Add New Category</h3>
                <div className='ms-auto d-flex gap-1'>
                  <RhyBusButton
                    disabled={isDisable}
                    label="Save"
                    aria-label="Save"
                    leftIcon="icon-rb-checked font-11 me-1"
                    onClick={() => addNewCat()} />
                  <RhyBusButton
                    label="Cancel"
                    aria-label="Cancel "
                    leftIcon="icon-rb-close font-11 me-1 "
                    onClick={() => {
                      setCatNewError(false)
                      setSeverityNewError(false)
                      setShowDiv(!showDiv)
                    }} />
                </div>
              </div>

              <div className="d-flex flex-column pt-0 card-body">
                <div className='row'>
                  <div className='col-sm-12 col-md-5'>
                    <RhyBusInputText
                      label="Category"
                      onChange={(e: any) => setCatName(e.target.value)}
                      id='category'
                      name='Category'
                      placeholder='Category'
                      size='sm'
                      value={catName}
                      error={catNewError}
                      maxLength={256}
                      isMandatory
                      iconLeft
                    />
                    <RhyBusCustomSelect
                    id='Severity'
            label="Severity"
            options={SELECT_VALUE}
            value={severity}
            onChange={setSeverity}
            isMandatory
          />
                    
                  </div>
                  <div className='col-sm-12 col-md-7'>
                    <RhyBusTextArea
            id="context"
            name="Context"
            label="Context"
            value={catContext}
            placeholder="Enter Context"
            rows={4}
            onChange={(e: any) => setCatContext(e.target.value)}
          />
                   
                  </div>
                </div>
              </div>
            </div>
          }
          <div className='piiaccordiongroup whitebg overflow-hidden userdefinedcat'>
            <EditableText Items={userDefinedCat} formats={piiFormates} getData={getPIIFormates} getCategories={getCategoryTypeData} isPredefinedCategories={false} />
          </div>
        </div>
      </div>
    </>
  )
}

export default PiiConfiguration
